import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ContractdateComponent } from './contractdate.component';
import { ContractdateDetailComponent } from './contractdate-detail.component';
import { ContractdatePopupComponent } from './contractdate-dialog.component';
import { ContractdateDeletePopupComponent } from './contractdate-delete-dialog.component';

import { Principal } from '../../shared';

export const contractdateRoute: Routes = [
  {
    path: 'contractdate',
    component: ContractdateComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contractdate.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'contractdate/:id',
    component: ContractdateDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contractdate.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const contractdatePopupRoute: Routes = [
  {
    path: 'contractdate-new',
    component: ContractdatePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contractdate.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'contractdate/:id/edit',
    component: ContractdatePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contractdate.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'contractdate/:id/delete',
    component: ContractdateDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.contractdate.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contractdate/contractdate.route.ts